export type FieldDerivedStateKey = keyof IFieldDerivedState;

export interface IFieldDerivedState {
  visible: boolean;
  enabled: boolean;
  layoutEnabled: boolean;
  required: boolean;
  warning: string | null;
}

export const DERIVED_STATE_KEYS: FieldDerivedStateKey[] = [
  'visible',
  'enabled',
  'layoutEnabled',
  'required',
  'warning',
];

export const DEFAULT_FIELD_DERIVED_STATE: IFieldDerivedState = {
  visible: true,
  enabled: true,
  layoutEnabled: true,
  required: false,
  warning: null,
};
